import { useFetchPageInfo } from "@/apis/queryFunctions/pageInfo";
import { useLocalContext } from "@/setup/locale-provider";
import { Box, Button, Table, Text } from "@mantine/core";
import Link from "next/link";
import { useRouter } from "next/router";
// import { useState } from "react";

export default function JobTable() {
  const { getLabel } = useLocalContext();
  // const [value, setValue] = useState({
  //   position: "",
  //   career: "",
  //   location: "",
  // });
  // const [subValue, setSubValue] = useState({
  //   position: "",
  //   career: "",
  //   location: "",
  // });
  const { locale } = useRouter();
  const { push } = useRouter();
  const { data: pageInfo } = useFetchPageInfo("trang-tuyen-dung", locale);
  const { add_on_data: data } = pageInfo || {};

  // console.log('data', pageInfo)
  // console.log('content_2', pageInfo?.content_2)

  const label = {
    vi: {
      thead: ["STT", "Vị trí tuyển dụng", "Ngành nghề", "Hạn nộp hồ sơ", ""],
      notification: "Hiện tại chưa có thông tin tuyển dụng nào",
      buttonSubmit: "Ứng tuyển",
    },
    en: {
      thead: ["NO.", "Vacancies", "Career", "Deadlines", ""],
      notification: "There are no job postings yet",
      buttonSubmit: "Apply",
    },
  };

  const rows =
    data &&
    data
      ?.filter((el) => el.shared)
      .map((element, index) => (
        // <Link key={index} href={`/tuyen-dung/${element.content_2}`}>
        //   {/* <a> */}
        //   {/* </a> */}
        // </Link>
        <tr
          key={index}
          style={{
            fontWeight: 500,
            // cursor: "pointer",
          }}
        >
          <td style={{ borderBottom: "none", width: "5%" }} key={`stt${index}`}>
            <Text size="sm" align="center">
              {index + 1}
            </Text>
          </td>
          <td
            style={{ borderBottom: "none", width: "30%" }}
            key={`position${index}`}
          >
            <Link key={index} href={`/tuyen-dung/${element.content_2}`}>
              <a>
                <Text size="sm">{getLabel(element.title)}</Text>
              </a>
            </Link>
          </td>
          <td
            style={{ borderBottom: "none", width: "30%" }}
            key={`career${index}`}
          >
            <Link key={index} href={`/tuyen-dung/${element.content_2}`}>
              <a>
                <Text size="sm" align="center">
                  {getLabel(element.content_3)}
                </Text>
              </a>
            </Link>
          </td>
          <td
            style={{ borderBottom: "none", width: "20%" }}
            key={`location${index}`}
          >
            {/* <Link key={index} href={`/tuyen-dung/${element.content_2}`}> */}
            {/* <a> */}
            <Text size="sm" align="right" weight={400}>
              {getLabel(element.summary)}
            </Text>
            {/* </a> */}
            {/* </Link> */}
          </td>
          <td
            style={{ borderBottom: "none", width: "15%" }}
            key={`button${index}`}
          >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                size="sm"
                sx={{ fontWeight: 500 }}
                onClick={() => push(`/tuyen-dung/${element.content_2}`)}
              >
                {label[locale]?.buttonSubmit}
              </Button>
            </Box>
          </td>
        </tr>
      ));
  // const onSubmit = (value) => {
  //   setValue(value);
  // };
  // const handleChangeLocation = (a) => {
  //   setSubValue({ ...subValue, location: a });
  // };
  // const handleChangeCareer = (a) => {
  //   setSubValue({ ...subValue, career: a });
  // };
  // function validateJob(job) {
  //   if (value.career != "" || value.location != "" || value.position != "") {
  //     // console.log();
  //     if (
  //       value.position != "" &&
  //       !removeVietnameseTones(job.position)
  //         .toUpperCase()
  //         .includes(removeVietnameseTones(value.position).toUpperCase())
  //     )
  //       return false;
  //     if (value.career != "" && job.career != value.career) return false;
  //     if (value.location != "" && job.location != value.location) return false;
  //   }
  //   return true;
  // }

  return (
    <>
      {/* <SimpleGrid
        cols={4}
        breakpoints={[{ maxWidth: 755, cols: 1, spacing: "sm" }]}
        sx={{ padding: "10px 0px" }}
      >
        <TextInput
          placeholder={getLabel("Điền vị trí ứng tuyển")}
          onChange={(event) =>
            setSubValue({ ...subValue, position: event.target.value })
          }
          //   required
        />
        <Select
          placeholder={getLabel("Chọn Chức vụ")}
          searchable
          //   allowDeselect
          //   unstyled
          value={subValue.career}
          styles={{
            item: {
              "&[data-selected]": {
                "&, &:hover": {
                  backgroundColor: "#17a29c",
                  color: "#ffffff",
                },
              },
            },
          }}
          maxDropdownHeight={280}
          data={[
            { value: "", label: "Chọn chức vụ" },
            { value: "Giám Đốc", label: "Giám Đốc" },
            { value: "IT", label: "IT" },
            { value: "Quản lý", label: "Quản lý" },
          ]}
          onChange={handleChangeCareer}
        />
        <Select
          placeholder={getLabel("Chọn địa điểm")}
          searchable
          value={subValue.location}
          styles={{
            item: {
              "&[data-selected]": {
                "&, &:hover": {
                  backgroundColor: "#17a29c",
                  color: "#ffffff",
                },
              },
            },
          }}
          //   clearable
          maxDropdownHeight={280}
          //   value={value.location}
          data={[
            { value: "", label: "Chọn địa điểm" },
            { value: "Tp. HCM", label: "Tp. HCM" },
            { value: "Huế", label: "Huế" },
            { value: "Hà Nội", label: "Hà Nội" },
          ]}
          onChange={handleChangeLocation}
        />
        <Button
          onClick={() => onSubmit(subValue)}
          variant="gradient"
          gradient={{ from: "#15a09b", to: "#1de5db" }}
        >
          {getLabel("Tìm Kiếm")}
        </Button>
      </SimpleGrid> */}

      <Table striped highlightOnHover>
        <thead>
          <tr>
            <th style={{ background: "#fff" }}>
              <Text size="md" weight={700}>
                {label[locale].thead[0]}
              </Text>
            </th>
            <th style={{ background: "#fff" }}>
              <Text size="md" weight={700}>
                {getLabel(label[locale].thead[1])}
              </Text>
            </th>
            <th style={{ background: "#fff" }}>
              <Text size="md" align="center">
                {getLabel(label[locale].thead[2])}
              </Text>
            </th>
            <th style={{ background: "#fff" }}>
              <Text size="md" align="right">
                {getLabel(label[locale].thead[3])}
              </Text>
            </th>
            <th style={{ background: "#fff" }}>
              <Text size="md" align="right">
                {/* {getLabel("Địa điểm")} */}
              </Text>
            </th>
          </tr>
        </thead>
        {data && data.length > 0 && <tbody>{rows}</tbody>}
      </Table>
      {data && data.length == 0 && (
        <Text size="sm" align="center" sx={{ paddingTop: 20 }}>
          {label[locale].notification}
        </Text>
      )}
    </>
  );
}
